export default (
    state = {
        loading: true,
        error: false,
        responseType: '',        
        message: '',
        data: {}
    }, action) => {
    switch (action.type) {

        case 'GET_GRAPH_DATA':
            return {
                ...state,
                loading: false,
                responseType:action.payload.responseType,
                data : action.payload.responseData,
            };
        

        default:

            return state;

    }

};